import {
  FETCH_BETAALMETHODES,
  FETCH_BETAALMETHODE,
  SAVE_BETAALMETHODE,
  TOGGLE_BETAALMETHODE,
  TEST_BETAALMETHODE,
  BETAALMETHODE_ERROR
} from "./types";

const API_URL = "/api/admin/betaalmethodes";

function handleResponse(response) {
  if (response.ok) {
    return response.json();
  } else {
    let error = new Error(response.statusText);
    error.response = response.statusText;
    throw error;
  }
}

// Haal alle betaalmethodes op
export const fetchBetaalmethodes = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(API_URL, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: FETCH_BETAALMETHODES,
      payload: data.results
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: BETAALMETHODE_ERROR,
      payload: error.message || "Fout bij ophalen betaalmethodes"
    });
    
    return { type: "BETAALMETHODE_ERROR", error: error.message };
  }
};

// Haal specifieke betaalmethode op
export const fetchBetaalmethode = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: FETCH_BETAALMETHODE,
      payload: data.result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: BETAALMETHODE_ERROR,
      payload: error.message || "Fout bij ophalen betaalmethode"
    });
    
    return { type: "BETAALMETHODE_ERROR", error: error.message };
  }
};

// Opslaan betaalmethode
export const saveBetaalmethode = (betaalmethodeData) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(betaalmethodeData)
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: SAVE_BETAALMETHODE,
      payload: data.result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: BETAALMETHODE_ERROR,
      payload: error.message || "Fout bij opslaan betaalmethode"
    });
    
    return { type: "BETAALMETHODE_ERROR", error: error.message };
  }
};

// Schakel betaalmethode in/uit
export const toggleBetaalmethode = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/${id}/toggle`, {
      method: 'PUT',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: TOGGLE_BETAALMETHODE,
      payload: data.result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: BETAALMETHODE_ERROR,
      payload: error.message || "Fout bij schakelen betaalmethode"
    });
    
    return { type: "BETAALMETHODE_ERROR", error: error.message };
  }
};

// Test betaalmethode configuratie
export const testBetaalmethode = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/${id}/test`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: TEST_BETAALMETHODE,
      payload: data.test_result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: BETAALMETHODE_ERROR,
      payload: error.message || "Fout bij testen betaalmethode"
    });
    
    return { type: "BETAALMETHODE_ERROR", error: error.message };
  }
};